import React, {useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import mime from 'mime-types';
import FilePreview from 'common/components/FilePreview';
import {pathnames as P} from 'common/constants/pathnames';

const FilePreviewHandler = ({
                              getFile,
                              fileExtension,
                              fileID,
                              children
                            }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const [content, setContent] = useState(null);
  const [type, setType] = useState(null);
  const [previewIsOpen, setPreviewIsOpen] = useState(false);
  const openPreview = () => {
    Promise.resolve()
      .then(() => setPreviewIsOpen(true))
      .then(() => getFile({shumaId, fileID}))
      .then(body => {
        const mimeType = mime.lookup(fileExtension);
        const previewType = getType();
        setType(previewType);

        return `data:${mimeType};base64,${body}`;
      })
      .then(dataUri => setContent(dataUri))
  };
  const closePreview = () => setPreviewIsOpen(false);

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };

  return (
    <>
      {children({openPreview})}
      <FilePreview
        type={type}
        isOpen={previewIsOpen}
        close={closePreview}
        dataURI={content}
      />
    </>
  )
};

export default FilePreviewHandler;